import { useEffect, useRef, useState } from "react";
import styles from "./Prop65GroupWarning.scss";
import { useRuntimeConstants } from "../../context/runtimeConstants/RuntimeConstantsContext";
import shouldShowProp65 from "../../utils/shouldShowProp65";
import { useIsInStockContext } from "../../context/isInStock/IsInStockContext";
import GreyBox from "../nonFunctionalComponents/greyBox/GreyBox";

export default function Prop65GroupWarning() {
  const { getTranslation, product } = useRuntimeConstants();
  const { isInStock } = useIsInStockContext();
  const [showProp65, setShowProp65] = useState(null);
  const mountedRef = useRef(true);

  useEffect(() => {
    return () => {
      mountedRef.current = false;
    };
  }, []);

  useEffect(() => {
    shouldShowProp65({ product, isInStock }).then((result) => {
      if (mountedRef.current) {
        setShowProp65(result);
      }
    });
  }, [product, isInStock]);

  if (showProp65 !== true) {
    return null;
  }

  return (
    <GreyBox>
      <span className={styles.icon}>
        <div className="product-warning-prop65"></div>
      </span>
      <p data-testid="prop65-group-message" className={styles.text}>
        {getTranslation("prop65_mandm_message_text")}
      </p>
    </GreyBox>
  );
}
